import { PaginationQuery, PaginationQueryDefaultValues } from "../pagination/pagination-query";

export interface MaterialList {
  id: string,
  materialName: string,
  materialId: string,
  type: string,
  language: string,
  course: string,
  tags: string,
  status: string,
  disabled: boolean
}

export function MaterialListDefaultValues(): MaterialList {
  return {
    id: '',
    materialName: '',
    materialId: '',
    type: '',
    language: '',
    course: '',
    tags: '',
    status: '',
    disabled: false
  };
}

export type MaterialQueryFilters = PaginationQuery & {
    MaterialNameKeyword: string,
    Type: number,
    Language: number,
    Course: number,
    Tag: number,
    Status: number
}

export function MaterialQueryFiltersDefaultValues(): MaterialQueryFilters {
    return {
        ...PaginationQueryDefaultValues(),
        MaterialNameKeyword: '',
        Type: 0,
        Language: 0,
        Course: 0,
        Tag: 0,
        Status: 0
    }
}

